const shopify = {
  footerMessagePaymentVia: 'ชำระเงินผ่าน',
  inputCustomerName: 'ชื่อ',
  inputCardExpiryDate: 'วันหมดอายุ',
  errorInsertCardExpiration: 'กรุณากรอกวันหมดอายุของบัตร',
  errorCardExpired: 'อุ๊ปส์! บัตรที่คุณกรอกหมดอายุแล้ว',
  errorInvalidExpirationDate: 'วันหมดอายุไม่ถูกต้อง',
  inputCardNumber: 'หมายเลขบัตร',
  inputCardSecurityCode: 'รหัสความปลอดภัย (CVV)',
  greeting: 'สวัสดี {customerName}',
  fillCardSecurityCode: 'กรุณากรอกรหัสความปลอดภัยของบัตร',
  invalidSecurityCode: 'รหัสความปลอดภัยไม่ถูกต้อง',
  invalidCvv: 'รหัสความปลอดภัยไม่ถูกต้อง',
  fillColombianAddress: 'กรุณากรอกที่อยู่',
  invalidColombianAddress: 'ที่อยู่ไม่ถูกต้อง',
};

module.exports = shopify;
